import React, { Component } from 'react'
import { Route, Switch, Redirect } from 'react-router-dom'

import Header from './Header'
import Menu from './Menu'
import PreviousActivities from './PreviousActivities'
import UpcomingActivities from './UpcomingActivities'
import FavoritesActivities from './FavoritesActivities'
import SwitchProTrackBlock from './SwitchProTrackBlock'
import * as IDENTITY_ACTIONS from 'app/constants/identityActions'

import './styles.scss'

const bs = 'different-activity'

export default class DifferentActivity extends Component {
  componentDidMount() {
    this.props.setActivitiesLoadStatusToDefault()
  }

  render() {
    const { match, actions, isUserCanSwitchProtrack } = this.props
    const canCommit = actions.has(IDENTITY_ACTIONS.COMMIT)
    if (!canCommit) {
      return <Redirect from={match.path} to={`/dashboard`} exact />
    }

    return (
      <div className={bs}>
        <Header />
        <div className={`${bs}__content`}>
          <Route path="/different-activity" component={Menu} />
          <div style={{ width: '100%' }}>
            <Switch>
              <Route path={`${match.path}/previous`} component={PreviousActivities} />
              <Route path={`${match.path}/upcoming`} component={UpcomingActivities} />
              <Route path={`${match.path}/favorites`} component={FavoritesActivities} />
              <Redirect from={match.path} to={`${match.path}/upcoming`} exact />
            </Switch>
            {isUserCanSwitchProtrack && <SwitchProTrackBlock />}
          </div>
        </div>
      </div>
    )
  }
}
